// Deliberately distinct keys from `adminStorage` ("admin_token"/"admin_user"):
// an org admin is NOT a superadmin, and both sessions must be able to coexist
// in one browser without either clobbering the other.
const ORG_ADMIN_TOKEN_KEY = "org_admin_token";
const ORG_ADMIN_USER_KEY = "org_admin_user";

export const orgAdminStorage = {
  getToken(): string | null {
    return localStorage.getItem(ORG_ADMIN_TOKEN_KEY);
  },
  getUser(): any | null {
    const raw = localStorage.getItem(ORG_ADMIN_USER_KEY);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch { return null; }
  },
  setSession(token: string, user: any): void {
    localStorage.setItem(ORG_ADMIN_TOKEN_KEY, token);
    localStorage.setItem(ORG_ADMIN_USER_KEY, JSON.stringify(user));
  },
  clearSession(): void {
    localStorage.removeItem(ORG_ADMIN_TOKEN_KEY);
    localStorage.removeItem(ORG_ADMIN_USER_KEY);
  },
};
